export { default as SocialIcons } from './SocialIcons';
